import _ from 'lodash'
import { colors, responsiveFontSizes } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
import { itIT } from '@material-ui/core/locale'
import { THEMES } from '@/constants'
import { softShadows, strongShadows } from './shadows'
import typography from './typography'

// variabili dei colori
export const basicColors = {
  darkGreen: '#4caf50',
  green: '#4caf50',
  lightGreen: '#C8F6CC',
  darkYellow: '#ff9800',
  lightYellow: '#FFF3E0',
  darkRed: '#f44336',
  lightRed: '#FFE0E0',
  lightBlue: '#d3e3ff',
  lightBlue2: '#E8F1F4',
  blueGrayDark: '#263238',
  blueGrayMedium: '#546E7A',
  blueGrayLight: '#B0BEC5',
  background: '#182638',
  backgroundGradient: 'linear-gradient(90deg, rgba(24,38,56,1) 0%, rgba(12,12,92,1) 44%, rgba(2,20,105,1) 100%)',
  nav: '#263d54',
  darkText: '#111111',
  whiteText: '#ffffff',
  primary: '#2cb950',
  disabled: '#9699a4',
  primaryGradient: 'linear-gradient(180deg, rgba(21,144,51,1) 0%, rgba(44,185,80,1) 33%, rgba(69,209,104,1) 100%)',
  secondary: '#4e87cc'
  // secondary: '#34ae6d'
  // background: '#1a232f',
  // background: '#222933',
  // background: '#171c24',
  // nav: '#253342',
  // nav: '#314e58',
  // secondary: '#36a175'
  // secondary: '#27517d',
  // secondary: '#1d9675',
  // primary: '#46cfd6',
  // primary: '#2dc653',
  // primary: '#31ba62',
  // primary: '#FF7A14',
  // primary: '#ccff33',
  // primary: '#9ef01a',
  // primary: '#5390d9',
  // primary: '#7f6fed',
}

const baseOptions = {
  direction: 'ltr',
  typography,
  overrides: {
    MuiLinearProgress: {
      root: {
        borderRadius: 3,
        overflow: 'hidden'
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: 32
      }
    },
    MuiChip: {
      root: {
        backgroundColor: 'rgba(0,0,0,0.075)'
      }
    },
    MuiButton: {
      root: {
        borderRadius: 16
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 16
      }
    },
    MuiPaper: {
      rounded: {
        borderRadius: '8px'
      }
    }
  }
}

// Doc for customizations
// https://material-ui.com/customization/default-theme/?expand-path=$.palette
// https://material-ui.com/customization/palette/
const themesOptions = [
  {
    name: THEMES.LIGHT,
    overrides: {
      MuiInputBase: {
        input: {
          '&::placeholder': {
            opacity: 1,
            color: colors.blueGrey[600]
          }
        }
      }
    },
    palette: {
      type: 'light',
      action: {
        active: '#1D6F9B'
      },
      background: {
        default: colors.common.white,
        dark: '#f4f6f8',
        paper: colors.common.white
      },
      primary: {
        main: '#06526F',
        alternative: '#1D6F9B'
      },
      secondary: {
        main: '#009DE0',
        alternative: '#139FD0'
      },
      alert: {
        error: basicColors.darkRed,
        warning: '#E4C548'
      },
      text: {
        primary: colors.blueGrey[900],
        secondary: colors.blueGrey[600]
      }
    },
    shadows: softShadows,
    redButton: {
      backgroundColor: colors.red[700],
      color: 'white',
      '&:hover': {
        backgroundColor: basicColors.darkRed
      }
    },
    greenButton: {
      backgroundColor: colors.green[600],
      color: 'white',
      '&:hover': {
        backgroundColor: colors.green[800]
      }
    }
  },
  {
    name: THEMES.ONE_DARK,
    overrides: {
      MuiCardHeader: {
        title: {
          color: basicColors.primary
        }
      },
      MuiTabs: {
        scrollButtonsDesktop: {
          color: basicColors.primary
        }
      },
      MuiAvatar: {
        colorDefault: {
          backgroundColor: 'rgba(245, 245, 245, 0.8)'
        }
      },
      MuiTableCell: {
        root: {
          borderBottom: '1px solid ' + basicColors.background
        }
      },
      MuiPaper: {
        outlined: {
          border: '1px solid rgb(0 0 0 / 22%)'
        }
      },
      MuiTooltip: {
        tooltip: {
          backgroundColor: '#fefefe',
          color: 'rgba(0, 0, 0, 0.87)',
          boxShadow: strongShadows[3],
          fontSize: 13
        }
      },
      MuiFormHelperText: {
        root: {
          fontWeight: 500
        }
      }
    },
    palette: {
      type: 'dark',
      /* action: {
        active: 'rgba(250, 250, 250, 0.54)',
        hover: 'rgba(250, 250, 250, 0.04)',
        selected: 'rgba(240, 240, 240, 0.08)',
        disabled: 'rgba(250, 250, 250, 0.26)',
        disabledBackground: 'rgba(250, 250, 250, 0.12)',
        focus: 'rgba(250, 250, 250, 0.12)'
      }, */
      background: {
        default: basicColors.nav, // nav
        dark: basicColors.background, // background
        paper: basicColors.nav // cards + more
      },
      text: {
        primary: '#efefef',
        secondary: '#ced1dc',
        icon: '#efefef'
      },
      primary: {
        main: basicColors.primary
      },
      secondary: {
        main: basicColors.secondary
      },
      error: {
        main: colors.red[600]
      },
      warning: {
        main: basicColors.darkYellow
      },
      success: {
        // light: '#8a85ff',
        main: basicColors.darkGreen
      },
      // info: {
      //  main: '#8a85ff',
      // },
      alert: {
        error: basicColors.darkRed,
        warning: basicColors.darkYellow
      }
    },
    shadows: strongShadows
  },
  {
    name: THEMES.UNICORN,
    palette: {
      type: 'dark',
      action: {
        active: 'rgba(255, 255, 255, 0.54)',
        hover: 'rgba(255, 255, 255, 0.04)',
        selected: 'rgba(255, 255, 255, 0.08)',
        disabled: 'rgba(255, 255, 255, 0.26)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        focus: 'rgba(255, 255, 255, 0.12)'
      },
      background: {
        default: '#2a2d3d',
        dark: '#222431',
        paper: '#2a2d3d'
      },
      primary: {
        main: '#a67dff'
      },
      secondary: {
        main: '#a67dff'
      },
      text: {
        primary: '#f6f5f8',
        secondary: '#9699a4'
      }
    },
    shadows: strongShadows
  }
]

export const createDashboardTheme = (config = {}) => {
  let themeOptions = themesOptions.find((theme) => theme.name === config.theme)

  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`))
    ;[themeOptions] = themesOptions
  }

  let theme = createTheme(_.merge({}, baseOptions, themeOptions, { direction: config.direction }), itIT)

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme)
  }

  return theme
}
